export default __webpack_public_path__ + "static/media/Pratyush_Kumar_Rai_Resume.67359c03.pdf";